export enum AIJobState {
    None = 0,
    Waiting = 1,
    Executed = 2
}